import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

@Injectable()
export class TodoRhProvider {
  constructor(public http: HttpClient, 
    public commonProvider: CommonProvider) {}

    private _urlTodos: string = this.commonProvider.apiUrl + 'api/v1/todos';

    getMobileUserTasks(): Observable<Response<any>> {
      return this.http.get<Response<any>>(this._urlTodos + '/getMobileUserTasks');
    }

    updateProcessTaskState(task_id, state): Observable<Response<any>> {
        return this.http.post<Response<any>>(this._urlTodos + '/updateProcessTaskState', {task_id, state});
      }

}




// WEBPACK FOOTER //
// ./src/providers/tasks/tasks.ts